import i18n from 'helper/i18n';
import { initialState, RootStateType } from '.';
import { GenderKeyType } from '../../types/GenderKey';

export const getHasUserBeenLoaded = (state: RootStateType) => {
	return state.profile.userDataLoaded;
};

export const getUserData = (state: RootStateType) => {
	if (state && state.profile && state.profile.userData) {
		return state.profile.userData;
	}

	return initialState.userData;
};

export const getTempPregnant = (state: RootStateType): boolean | null => {
	if (state && state.profile && state.profile.userData) {
		return state.profile.userData.tempPregnant;
	}

	return null;
};

export const getTempAcceptedPregnancyWarning = (state: RootStateType): boolean | null => {
	if (state && state.profile && state.profile.userData) {
		return state.profile.userData.tempAcceptedPregnancyWarning;
	}

	return null;
};

export const getError = (state: RootStateType) => {
	if (state && state.profile) {
		return state.profile.error;
	}

	return initialState.error;
};

export const getGender = (state: RootStateType): GenderKeyType | null => {
	const userData = getUserData(state);
	if (userData !== null) {
		return userData.gender;
	}
	return null;
};

export const getPoints = (state: RootStateType): string | null => {
	const userData = getUserData(state);
	if (userData !== null) {
		return userData.points;
	}
	return null;
};

export const getLevel = (state: RootStateType): string | null => {
	const userData = getUserData(state);
	if (userData !== null) {
		return userData.level;
	}
	return null;
};

export const getAge = (state: RootStateType): number | null => {
	const userData = getUserData(state);
	if (userData !== null) {
		const today = new Date();
		const birthDate = new Date(userData.birthdate.date);
		let age = today.getFullYear() - birthDate.getFullYear();
		const m = today.getMonth() - birthDate.getMonth();
		if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
			age--;
		}
		return age;
	}
	return null;
};

export const getParticipateCompetition = (state: RootStateType) => {
	const userData = getUserData(state);
	if (userData !== null) {
		return userData.participateCompetition;
	}
	return null;
};

export const getWeightReduceGoal = (state: RootStateType) => {
	if (state && state.profile && state.profile.userData) {
		return state.profile.userData.weightReduceGoal;
	}

	return null;
};

export const getSuggestedWeightReduceGoal = (state: RootStateType) => {
	if (state && state.profile && state.profile.userData) {
		return state.profile.userData.suggestedWeightReduceGoal;
	}

	return null;
};

export const getHeight = (state: RootStateType) => {
	const userData = getUserData(state);
	if (userData !== null) {
		return userData.height;
	}
	return null;
};

export const getCoach = (state: RootStateType) => {
	const userData = getUserData(state);
	if (userData !== null) {
		return userData.coach;
	}
	return null;
};

export const getWeight = (state: RootStateType) => {
	const userData = getUserData(state);
	if (userData !== null) {
		return userData.weight;
	}
	return null;
};

export const getDsgvo = (state: RootStateType) => {
	const userData = getUserData(state);
	if (userData !== null) {
		if (userData.dsgvo === 'UNKNOWN') {
			return null;
		}
		return userData.dsgvo === 'TRUE';
	}
	return null;
};

export const getShowDsgvoReminder = (state: RootStateType): boolean => {
	const userData = getUserData(state);
	if (userData !== null) {
		return userData.showDsgvoReminder;
	}
	return false;
};

export const getBirthdate = (state: RootStateType) => {
	const userData = getUserData(state);
	if (userData !== null) {
		return userData.birthdate;
	}
	return null;
};

export const getHealthTarget = (state: RootStateType) => {
	const userData = getUserData(state);
	if (userData !== null) {
		return userData.healthGoal;
	}
	return null;
};

export const getIntensity = (state: RootStateType) => {
	const userData = getUserData(state);
	if (userData !== null) {
		return userData.intensity;
	}
	return null;
};

export const getFirstName = (state: RootStateType) => {
	const userData = getUserData(state);
	if (userData !== null) {
		return userData.firstName;
	}
	return null;
};

export const getLastName = (state: RootStateType) => {
	const userData = getUserData(state);
	if (userData !== null) {
		return userData.lastName;
	}
	return null;
};

export const getEmail = (state: RootStateType) => {
	const userData = getUserData(state);
	if (userData !== null) {
		return userData.email;
	}
	return null;
};

export const getBmi = (state: RootStateType) => {
	const userData = getUserData(state);
	if (userData !== null) {
		return userData.bmi;
	}
	return null;
};

export const getSlogan = (state: RootStateType) => {
	const userData = getUserData(state);

	if (userData === null || !userData.slogan || userData.slogan === '') {
		return i18n('react.impulsCoach.sloganFallback');
	}

	return userData.slogan;
};

export const getCreationDate = (state: RootStateType) => {
	const userData = getUserData(state);

	if (userData && userData.creationDate) {
		return userData.creationDate.date;
	}

	return null;
};
export const getCreationDateTime = (state: RootStateType): string | null => {
	const userData = getUserData(state);

	if (userData && userData.creationDate) {
		return userData.creationDate.time;
	}

	return null;
};

export const getIsUpdatingSlogan = (state: RootStateType) => {
	const userData = getUserData(state);
	return Boolean(!userData || userData.isUpdatingSlogan);
};

export const getIsPregnant = (state: RootStateType) => {
	if (state && state.profile && state.profile.userData) {
		return state.profile.userData.pregnant;
	}

	return null;
};

export const getWeightReduceMin = (state: RootStateType) => {
	if (state && state.profile && state.profile.userData) {
		return state.profile.userData.minWeight;
	}

	return null;
};

export const getWeightReduceMax = (state: RootStateType) => {
	if (state && state.profile && state.profile.userData) {
		return state.profile.userData.maxWeight;
	}

	return null;
};

export const getNutritionPhilosophy = (state: RootStateType) => {
	if (state && state.profile && state.profile.userData) {
		return state.profile.userData.nutritionPhilosophy;
	}

	return null;
};

export const getAllergies = (state: RootStateType) => {
	if (state && state.profile && state.profile.userData) {
		return state.profile.userData.allergies;
	}

	return null;
};

export const getActivityLevel = (state: RootStateType) => {
	if (state && state.profile && state.profile.userData) {
		return state.profile.userData.intensity;
	}

	return null;
};

export const getHealthGoal = (state: RootStateType) => {
	if (state && state.profile && state.profile.userData && state.profile.userData.healthGoal) {
		return state.profile.userData.healthGoal;
	}

	return null;
};

export const getTempHealthGoal = (state: RootStateType) => {
	if (state && state.profile && state.profile.userData && state.profile.userData.tempHealthGoal) {
		return state.profile.userData.tempHealthGoal;
	}

	return null;
};

export const getGenderMeta = (state: RootStateType) => {
	if (state && state.profile && state.profile.userData) {
		return {
			acceptedPregnancyWarning: state.profile.userData.acceptedPregnancyWarning,
			pregnant: state.profile.userData.pregnant,
		};
	}

	return {
		acceptedPregnancyWarning: false,
		pregnant: false,
	};
};

export const getFullName = (state: RootStateType) => {
	if (state && state.profile && state.profile.userData) {
		try {
			const firstName = state.profile.userData.firstName;
			const lastName = state.profile.userData.lastName;

			return `${firstName} ${lastName}`;
		} catch (err) {
			// do nothing
		}
	}

	return null;
};

export const getDisclaimerAccepted = (state: RootStateType) => {
	if (state && state.profile) {
		return !!(state.profile as any).anamnesisDisclaimerAccepted;
	}

	return false;
};

export const getIsAnamnesisDone = (state: RootStateType) => {
	if (state && state.profile && state.profile.userData && state.profile.userData.anamnesisDone) {
		return state.profile.userData.anamnesisDone;
	}

	return false;
};

export const getIsPreviewUser = (state: RootStateType) => {
	if (state && state.profile && state.profile.userData && state.profile.userData.previewUser) {
		return state.profile.userData.previewUser;
	}

	return false;
};

export const getIsProfileLoaded = (state: RootStateType) => {
	return state.profile.userDataLoaded;
};

export const getIsLoadingProfile = (state: RootStateType) => {
	return state.profile.isLoadingUserData;
};

export const getWaitForValues = (state: RootStateType) => {
	return state.profile.waitForValues;
};

export const getIsLoadingFinishOnboarding = (state: RootStateType) => {
	return !!state.profile.isLoadingFinishOnboarding;
};
export const getIsUpdatingAnamnesis = (state: RootStateType) => {
	return state.profile.isUpdatingAnamnesis;
};
